<template>
  <div>
    <Chart :cdata="cdata" />
  </div>
</template>

<script>
import Chart from './chart.vue'
import { formatTime } from '../../../../utils/index.js'
export default {
  data () {
    return {
      cdata: {
        category: [ ],
        lineData: [
          560,
          547,
          489,
          509,
          610,
          537,
          543,
          438,
          489,
          524,
          510,
          546,
          536,
          620,
          610,
          568,
          420,
          460,
          520,
          627,
          659,
          619,
          565,
          537,
          560,
          390,
          467,
          458,
          547,
          567,
          589,
          489,
          527
        ],
        barData: [
          4600,
          5300,
          5500,
          6500,
          7500,
          8500,
          7900,
          6500,
          8000,
          8590,
          7689,
          5780,
          6980,
          7300,
          4700,
          5500,
          5800,
          6500,
          7500,
          8400,
          6900,
          6785,
          7680,
          8765,
          8500,
          7590,
          6580,
          5700,
          7890,
          8100,
          9209,
          8760,
          7550
        ],
        rateData: [
          890,
          780,
          560,
          720,
          870,
          769,
          910,
          850,
          920,
          589,
          870,
          920,
          870,
          900,
          760,
          740,
          680,
          800,
          920,
          800,
          850,
          970,
          600,
          500,
          560,
          690,
          700,
          756,
          780,
          820,
          890,
          810,
          849
        ]
      }
    };
  },
  components: {
    Chart,
  },
  mounted () {
    this.setData();
  },
  methods: {
     // 根据自己的业务情况修改
    setData () {
      for (let i = 0; i < 33; i++) {
        // 获取当前日期
        let currentDate = new Date();
        // 获取前一天日期
        let previousDate = new Date(currentDate);
        let rate = formatTime(previousDate.setDate(currentDate.getDate() - (32-i)), 'MM-dd')
        this.cdata.category.push(rate);
      }
    }, 
  }
};
</script>

<style lang="scss" scoped>
</style>